import { API, graphqlOperation } from "aws-amplify";
import { configureGenericAppSync } from "../../context/AuthContextUtility";


export const getBoffinComputesWithStartedStatus = async () => {

    await configureGenericAppSync();

    const variables = {
        limit: 100000
    }

    let computes = []
    let qry = `query MyQuery($limit: Int!, $nextToken: String) {
                    listUI4BI_BoffinComputeInfos(limit: $limit , filter: {lockStatus: {eq: "Started"}}, nextToken: $nextToken){
                    items {
                        accounts
                        createDate
                        datasets
                        id
                        jeTypes
                        ledgerTypes
                        pre_signed_url
                        teamName
                        processRow
                        processStatus
                        percentageCompleted
                        userId
                        recompute
                        latestRequestType
                        lastStartedDate
                        showPostingButton
                        filterOption
                        selectedLedgers
                        periodMonth
                        periodYear
                        showPostingButton
                        isAllJEPosted
                        wdLink
                        selectedCompanyCodes
                        postingStatus
                        lockStatus
                    }
                    nextToken
                    }
                }
            `;

    let startedResponse = await API.graphql(graphqlOperation(qry, variables));
    computes = computes.concat(startedResponse.data.listUI4BI_BoffinComputeInfos.items);
    while (startedResponse.data.listUI4BI_BoffinComputeInfos.nextToken) {
        variables["nextToken"] = startedResponse.data.listUI4BI_BoffinComputeInfos.nextToken
        startedResponse = await API.graphql(graphqlOperation(qry, variables));
        computes = computes.concat(startedResponse.data.listUI4BI_BoffinComputeInfos.items)
    }
    return computes;
    
}

export const updateBoffinComputeLockStatus = async (computeId, lockStatus) => {

    await configureGenericAppSync();

    let qry = `
    mutation MyMutation {
      updateUI4BI_BoffinComputeInfo(input: {id: "${computeId}", lockStatus :"${lockStatus}"})
            {
              id
              lockStatus
            }
    }`;
    let response = await API.graphql(graphqlOperation(qry));
    return response.data.updateUI4BI_BoffinComputeInfo;


}

// Tags an existing compute record with its request origin for the UI (e.g. "Recompute",
// "OverrideFileUpload") and stamps the run-start time. latestRequestType is a UI-only field, independent
// of the recompute field that the backend reads for the downloadable report. A recompute reuses the
// original compute record, so without this the banner would mislabel a recompute as a plain compute
// and compute Elapsed from the ORIGINAL createDate rather than this run's actual start.
export const setBoffinComputeRequestType = async (computeId, requestType, lastStartedDate) => {

    await configureGenericAppSync();

    let qry = `
    mutation MyMutation {
      updateUI4BI_BoffinComputeInfo(input: {id: "${computeId}", latestRequestType :"${requestType}", lastStartedDate :"${lastStartedDate}"})
            {
              id
              latestRequestType
              lastStartedDate
            }
    }`;
    let response = await API.graphql(graphqlOperation(qry));
    return response.data.updateUI4BI_BoffinComputeInfo;


}

export const resetBoffinComputeApprovalStatus = async (computeId) => {

    await configureGenericAppSync();

    let qry = `
    mutation MyMutation {
      updateUI4BI_BoffinComputeInfo(input: {id: "${computeId}", isApproved :"No"})
            {
              id
            }
    }`;
    let response = await API.graphql(graphqlOperation(qry));
    return response.data.updateUI4BI_BoffinComputeInfo;


}

export const getBoffinComputeStatus = async (computeId) => {

    await configureGenericAppSync();

    let qry = `
    query MyQuery {
      getUI4BI_BoffinComputeInfo(id: "${computeId}") {
        id
        processStatus
        percentageCompleted
        lockStatus
      }
    }`;
    let response = await API.graphql(graphqlOperation(qry));
    return response.data.getUI4BI_BoffinComputeInfo;


}

// Fetch a single compute's metadata by id for the "Now processing" banner. Unlike
// getBoffinComputesWithStartedStatus (filtered on lockStatus = "Started"), this reads the record
// directly, so the banner can fill in metadata even in the brief window before lockStatus flips to
// "Started" — otherwise a live event shows the bar with empty "-" metadata until a reload.
export const getBoffinComputeMeta = async (computeId) => {

    await configureGenericAppSync();

    let qry = `
    query MyQuery {
      getUI4BI_BoffinComputeInfo(id: "${computeId}") {
        id
        processStatus
        percentageCompleted
        userId
        createDate
        lastStartedDate
        periodMonth
        periodYear
        recompute
        latestRequestType
        lockStatus
      }
    }`;
    let response = await API.graphql(graphqlOperation(qry));
    return response.data.getUI4BI_BoffinComputeInfo;


}
